import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons'

const DebitCardSignalsTable = ({ data }) => (
  <div className="box mb-4 ml-2 mr-2">
    <h4 className="title is-6 mb-3">
      <FontAwesomeIcon icon={faShieldHalved} className="mr-2" />
      Debit Card Signals
    </h4>
    <div className="list-table-container">
      <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <tr className="is-selected">
            <th className="is-selected has-text-centered is-nowrap">Last 4 Digits</th>
            <th className="is-selected has-text-centered is-nowrap">Auto-Flagged</th>
            <th className="is-selected has-text-centered is-nowrap">Message</th>
          </tr>
        </thead>
        <tbody>
          {data.map((signal) => (
            <tr key={`debit-card-${signal.lastFourDebitCardNumber}-${signal.debitCardIndicatorMessage}`}>
              <td className="has-text-centered is-nowrap">****{signal.lastFourDebitCardNumber}</td>
              <td className="has-text-centered is-nowrap">
                <span className={`tag ${signal.autoflaggeddebit ? 'is-warning' : 'is-light'}`}>
                  {signal.autoflaggeddebit ? 'Yes' : 'No'}
                </span>
              </td>
              <td className="has-text-centered">{signal.debitCardIndicatorMessage}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

export default DebitCardSignalsTable
